import { useFormik } from 'formik';

import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@store/hooks';
import CustomAlert from '@components/Shared/Alert/CustomAlert';

import { Form } from 'react-bootstrap';
import { ReceiptsCreateAccount } from '@store/Finance/AR/ArReceipts/ArReceiptsSlice';
import { useState } from 'react';
import { Card, CardBody } from '@components/card/card';

interface Props {
  selectedApPayments: any[];
}

const AddCreateAccountArReceipts = ({ selectedApPayments }: Props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const [responseData, setResponseData] = useState<any[]>([]);

  // const formik = useFormik({
  //   initialValues: {
   //     periodId: '',
  //     glDate: '',
  //   },
  //   validationSchema: CreateAccountSchema(t),
  //   onSubmit: (values) => {
  //     let ids = selectedApPayments.map((m) => m.id);

  //     const body = {
  //       transections: ids,
  //       periodId: values.periodId,

  //       glDate: values.glDate,
  //     };

  //     if (!isDateValid) {
  //       SwalAlert({ text: t('InvalidDateInPeriod') });
  //       formik.setSubmitting(false);
  //       return;
  //     }

  //     dispatch(ReceiptsCreateAccount(body))
  //       .unwrap()
  //       .then((res) => {
  //         if (res.succeeded) {
  //           CustomAlert({
  //             action: 'info',
  //             msg: t('PostSuccessMessage'),
  //           });
  //         } else {
  //           CustomAlert({
  //             action: 'Error',
  //             msg: res.message,
  //           });
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         CustomAlert({ action: 'Error', msg: error });
  //       })
  //       .finally(() => {
  //         formik.setSubmitting(false);
  //       });
  //   },
  // });

  const formik = useFormik({
    initialValues: {},

    // validationSchema: CreateAccountSchema(t),
    onSubmit: values => {
      const ids = selectedApPayments.map(m => m.id);

      const body = {
        transections: ids
      };

      dispatch(ReceiptsCreateAccount(body))
        .unwrap()
        .then((res: any) => {
          if (res.succeeded) {
            setResponseData(res.data || []);
            CustomAlert({
              action: 'info',
              msg: t('PostSuccessMessage')
            });
          } else {
            CustomAlert({
              action: 'Error',
              msg: res.message
            });
          }
        })
        .catch((error: any) => {
          console.log(error);
          CustomAlert({ action: 'Error', msg: error });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });

  return (
    <>
      <div className='table-responsive   mb-2'>
        <table className='table  table-sm table-bordered'>
          <thead className='bg-theme bg-opacity-10 '>
            <tr>
              <th className='pt-2 pb-2'>{t('VoucherNumber')}</th>
              <th className='pt-2 pb-2'>{t('Customer')}</th>
              <th className='pt-2 pb-2'>{t('Date')}</th>
              <th className='pt-2 pb-2'>{t('Amount')}</th>
            </tr>
          </thead>

          <tbody>
            {selectedApPayments?.map((item, index) => (
              <tr key={item.id}>
                <td className='align-middle'>{item.code}</td>
                <td className='align-middle'>{i18n.language === 'en' ? item.peopleName : item.peopleName2}</td>
                <td className='align-middle'>{item.paymentDate?.toString()?.split('T')[0]} </td>
                <td className='align-middle'>{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {responseData.length > 0 && (
        <div className='mt-2'>
          {/* Card للرسالة */}
          <Card className='card border-success mb-4 shadow-sm'>
            <CardBody className='card-body d-flex align-items-center text-success'>
              <i className='fas fa-check-circle text-success me-2 fs-4'></i>
              <span className='fs-5 fw-semibold'>{t('تمت العملية بنجـاح ( راجع التفاصيل .. )')}</span>
            </CardBody>
          </Card>

          {/* Card لجدول التفاصيل */}
          <div className='card shadow-sm border-0'>
            <div className='card-body p-0'>
              <div className='table-responsive'>
                <table className='table table-striped table-hover align-middle mb-0'>
                  <thead className='table-light'>
                    <tr>
                      <th>{t('code')}</th>
                      <th>{t('type')}</th>
                      <th>{t('activeFlag')}</th>
                      <th>{t('validOnDate')}</th>
                      <th>{t('رسالة الخطأ او النجاح')}</th>
                      <th>{t('الحالة')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseData.map((item, index) => (
                      <tr key={index} style={{ verticalAlign: 'middle' }}>
                        <td className='fw-medium'>{item.code}</td>
                        <td>{i18n.language === 'en' ? item.type : item.type2}</td>
                        <td>
                          {item.activeFlag ? (
                            <span className='badge bg-success'>{t('Yes')}</span>
                          ) : (
                            <span className='badge bg-danger'>{t('No')}</span>
                          )}
                        </td>
                        <td>{item.validOnDate?.split('T')[0] || '-'}</td>
                        <td>
                          <span className='text-danger'>{item.errorMessage || '-'}</span>
                        </td>
                        <td>
                          {item.succeeded ? (
                            <span className='text-success'>
                              <i className='fas fa-check-circle me-1'></i> {t('Success')}
                            </span>
                          ) : (
                            <span className='text-danger'>
                              <i className='fas fa-times-circle me-1'></i> {t('Failed')}
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      <Form onSubmit={formik.handleSubmit}>
        <div className='row'>
          <div className='col-6'>
            <button
              type='submit'
              className='btn btn-lg btn-theme  w-100 rounded-0'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {formik.isSubmitting ? (
                <div className='spinner-border spinner-border-sm me-2'></div>
              ) : (
                <i className='fas fa-lg fa-fw me-2 fa-check-circle'></i>
              )}
              {t('Post')}
            </button>
          </div>
          <div className='col-6'>
            <button type='button' className='btn btn-lg  btn-default   w-100 rounded-0' data-bs-dismiss='modal'>
              <i className='fas fa-times-circle fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddCreateAccountArReceipts;
